import React from "react";

const Error404 = () => {
  return <div>Error 404 : Page not found</div>;
};

export default Error404;
